import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ViberButton from "./components/ViberButton";
import GoToTopButton from "./components/GoToTopButton";
import HomePage from "./pages/HomePage";
import HamalskiUslugiPage from "./pages/HamalskiUslugiPage";
import TransportniUslugiPage from "./pages/TransportniUslugiPage";
import OfisHamaliPage from "./pages/OfisHamaliPage";
import PochistvamePage from "./pages/PochistvamePage";
import KontaktiPage from "./pages/KontaktiPage";
import "./App.css";

function App() {
  return (
    <div className="App" style={{ backgroundColor: '#0A0A0A', minHeight: '100vh' }}>
      <BrowserRouter>
        <Navbar />
        <ScrollToTop />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hamalski-uslugi" element={<HamalskiUslugiPage />} />
            <Route path="/transportni-uslugi" element={<TransportniUslugiPage />} />
            <Route path="/ofis-hamali" element={<OfisHamaliPage />} />
            <Route path="/pochistvane" element={<PochistvamePage />} />
            <Route path="/kontakti" element={<KontaktiPage />} />
          </Routes>
        </main>
        <Footer />
        <ViberButton />
        <GoToTopButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
